/**
 * Формат пути прокси — единственное, что знают о нём обе стороны.
 *
 * Модуль намеренно не зависит ни от браузера, ни от Node: его импортирует
 * и клиент (`utils/proxyUrl.ts`), и dev-сервер (`devProxy.ts`), и nginx
 * повторяет ту же схему в `deploy/nginx.conf`. Любое расхождение между
 * заворачиванием и разворотом увело бы планшет не на тот сервер.
 */

export const PROXY_PREFIX = '/__proxy/';

/** Схемы, которые прокси соглашается пересылать. */
const ALLOWED_SCHEMES: readonly string[] = ['http', 'https'];

/**
 * `https://lp.hron.uz/v1/x?a=1` → `/__proxy/https/lp.hron.uz/v1/x?a=1`.
 *
 * Относительный адрес и уже завёрнутый путь возвращаются как есть: первый
 * и так идёт на свой origin, второй уже завёрнут.
 */
export function encodeProxyPath(absoluteUrl: string): string {
  if (absoluteUrl.startsWith(PROXY_PREFIX)) return absoluteUrl;

  const match = /^(https?):\/\/(.+)$/i.exec(absoluteUrl);
  if (match === null) return absoluteUrl;

  return `${PROXY_PREFIX}${match[1].toLowerCase()}/${match[2]}`;
}

/**
 * `/__proxy/https/lp.hron.uz/v1/x?a=1` → `https://lp.hron.uz/v1/x?a=1`.
 *
 * `null`, если путь не наш, схема чужая (`file`, `gopher`) или цели нет.
 * На этой проверке стоит защита прокси-обработчика.
 */
export function decodeProxyPath(requestUrl: string): string | null {
  if (!requestUrl.startsWith(PROXY_PREFIX)) return null;

  const rest = requestUrl.slice(PROXY_PREFIX.length);
  const slash = rest.indexOf('/');
  if (slash < 0) return null;

  const scheme = rest.slice(0, slash);
  if (!ALLOWED_SCHEMES.includes(scheme)) return null;

  const target = rest.slice(slash + 1);
  if (target.length === 0) return null;

  return `${scheme}://${target}`;
}
